export const gallery: { [key: string]: string[] } = {
  production: ["http://evrotom.highlandesigns.com/image1.jpg"],
  products: [],
  workspace: [],
  team: [],
}

export const galleryKeys = Object.keys(gallery)
galleryKeys.unshift("all")
